export * from './LineEllipsis';
